exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "thead[data-v-4061ff78]{background-color:#e9ecef}.permission-group[data-v-4061ff78]{background:#faf9f9}.permission-group td[data-v-4061ff78]{font-weight:700}.permission-name[data-v-4061ff78],.sub-name[data-v-4061ff78]{min-height:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4061ff78","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/inventory/tax/add-tags-form.vue
// module id = xbNP
// module chunks = 113